export default __webpack_public_path__ + "static/zuzanna_sobczyk-4990542cdd0c7492e9875f656ded2e76.png";